<template>
    <div class="load">
        <div class="one"></div>
        <div class="two"></div>
        <div class="three"></div>
    </div>
</template>

<style>
    .load.hide {
        display: none !important;
    }

    .load {
        opacity: 0.7;
        position: absolute;
        height: 100vh;
        width: 100vw;
        background-color: whitesmoke;
        top: 0px;
        left: 0px;
        display: flex;
        justify-content: center;
        z-index: 99999 !important;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        align-items: center;
    }

        .load div {
            width: 20px;
            height: 20px;
            background-color: #ff54f9;
            border-radius: 50%;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            -ms-border-radius: 50%;
            -o-border-radius: 50%;
            margin: 0 5px;
            animation-name: up-and-down;
            animation-duration: 0.9s;
            animation-iteration-count: infinite;
            animation-direction: alternate;
        }

        .load .two {
            animation-delay: 0.3s;
        }

        .load .three {
            animation-delay: 0.6s;
        }

    @keyframes up-and-down {
        to {
            opacity: 0.2;
            transform: translateY(-20px);
            -webkit-transform: translateY(-20px);
            -moz-transform: translateY(-20px);
            -ms-transform: translateY(-20px);
            -o-transform: translateY(-20px);
        }
    }
</style>